/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function DefaultFooter({ variant = "" }) {
  const footerClassName = variant === "dark"
    ? "footer footer-default site-dark-footer site-bg-dark-navy"
    : "footer footer-default";

  return (
    <>
      <footer className={footerClassName}>
        <Container>
          <nav>
            <ul>
              <li>
              <a href="https://www.facebook.com/endgamesportdogs">
                <img
                    alt="Endgame Sport Dogs Facebook page"
                    className="img-fluid"
                    src={variant == "dark" ? require("../../assets/img/facebook-white.png") : require("../../assets/img/facebook3.png")}
                  />
                </a>
              </li>
            </ul>
          </nav>
          <div className="copyright" id="copyright">
            © {new Date().getFullYear()}, {" "}
            <a
              href="mailto:adriana@endgamedogs.com"
              target="_blank"
            >
              Endgame Sport Dogs, Adriana Nottestad
            </a>.
          </div>
        </Container>
      </footer>
    </>
  );
}

export default DefaultFooter;
